import React from 'react';
import ActividadesList from '../../Actividades/ActividadesList';

const FiscalizacionDetailRow = ({ row, externalRefetch, onStatusChange }) => {
	const inspectionId = row.original._id;
	return <ActividadesList inspectionId={inspectionId} externalRefetch={externalRefetch} onStatusChange={onStatusChange} />;
};

export default FiscalizacionDetailRow;
